import { contextGlobalExternalByShareTokenGetV2 } from "@btnet/services-btnet/handlers/context/context";

import { type IAppProviderHandler } from "helpers/AppProvider.api.handler";
import { GlobalInfo } from "helpers/AppProvider.types";

/**
 * Resolves global info for an anonymous share link, where the share token — not a session — names
 * the builder. Wire this in wherever a `/app/share/*` subtree mounts its own `AppProvider`, so
 * `BuilderInfoContext` is populated and consumers can keep asserting it with
 * `useRequiredContext`. See ADO 289189.
 */
export class AppProviderShareTokenHandler implements IAppProviderHandler {
    isLegacy = false;

    constructor(private readonly shareToken: string) {}

    /**
     * The token is part of the key because it selects the builder: two share links open in the same
     * session must not read each other's global info out of the cache.
     */
    get cacheKey() {
        return `shareToken:${this.shareToken}`;
    }

    async get(): Promise<GlobalInfo> {
        const response = await contextGlobalExternalByShareTokenGetV2(this.shareToken);
        // `GlobalInfo` types its input as the shape of AppProvider.api.json rather than the
        // generated `GlobalInfoResponse`; the two describe the same payload, and the legacy
        // `APIHandler` path erases the difference by constructing from `any`.
        return new GlobalInfo(
            response.data as unknown as ConstructorParameters<typeof GlobalInfo>[0],
        );
    }
}
